<template>
  <div class="flex flex-col gap-3">
    <a
      :href="mapUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center gap-3 p-3 rounded-lg transition-colors group"
    >
      <div
        class="flex-shrink-0 w-11 h-11 rounded-full flex items-center justify-center"
        :class="
          isSent
            ? 'bg-[var(--p-primary-200)]/50 dark:bg-[var(--p-primary-700)]/35'
            : 'bg-neutral-800/10 dark:bg-neutral-200/10'
        "
      >
        <MapPin
          :size="20"
          :stroke-width="2"
          :class="
            isSent
              ? 'text-[var(--p-primary-900)] dark:text-[var(--p-primary-100)]'
              : 'text-[var(--p-surface-900)] dark:text-[var(--p-surface-0)]'
          "
        />
      </div>

      <div class="flex-1 min-w-0">
        <p
          class="font-medium text-sm leading-snug mb-1"
          :class="
            isSent
              ? 'text-[var(--p-primary-950)] dark:text-[var(--p-primary-50)]'
              : 'text-[var(--p-surface-900)] dark:text-[var(--p-surface-0)]'
          "
        >
          {{ name || 'Ubicación compartida' }}
        </p>
        <p
          v-if="address"
          class="text-xs leading-relaxed truncate"
          :class="
            isSent
              ? 'text-[var(--p-primary-900)]/75 dark:text-[var(--p-primary-100)]/75'
              : 'text-[var(--p-surface-700)] dark:text-[var(--p-surface-300)]'
          "
        >
          {{ address }}
        </p>
        <p
          v-else
          class="text-xs leading-relaxed"
          :class="
            isSent
              ? 'text-[var(--p-primary-900)]/75 dark:text-[var(--p-primary-100)]/75'
              : 'text-[var(--p-surface-700)] dark:text-[var(--p-surface-300)]'
          "
        >
          {{ latitude }}, {{ longitude }}
        </p>
      </div>

      <ExternalLink
        :size="16"
        :stroke-width="2"
        class="flex-shrink-0 opacity-60 group-hover:opacity-100 transition-opacity"
        :class="
          isSent
            ? 'text-[var(--p-primary-900)] dark:text-[var(--p-primary-100)]'
            : 'text-[var(--p-surface-900)] dark:text-[var(--p-surface-0)]'
        "
      />
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { MapPin, ExternalLink } from 'lucide-vue-next'

interface Props {
  longitude: string
  latitude: string
  name?: string
  address?: string
  isSent: boolean
}

const props = defineProps<Props>()

const mapUrl = computed(() => {
  return `https://www.google.com/maps/search/?api=1&query=${props.latitude},${props.longitude}`
})
</script>
